// extracted by mini-css-extract-plugin
module.exports = {"Main":"DataEditorCellEditWrp_Main__25r_H"};